export const extractUrlValue = (query: string, key: string): string | undefined => {
  const regexp = `${key}=([^&]*)`
  const matches = query?.match(regexp)
  const res = matches?.[1]
  return res && res != '' ? decodeURIComponent(res.replace(/\+/g, ' ')) : undefined
}
